export const GEO_ACCESS = {
  MKT: 'MKT',
  OFFICE: 'OFFICE',
} as const;

export type GeoAccess = (typeof GEO_ACCESS)[keyof typeof GEO_ACCESS];

export function decodeGeoAccess(accessToken: string | null): GeoAccess {
  if (!accessToken) return GEO_ACCESS.MKT;

  try {
    const segment = accessToken.split('.')[1];
    if (!segment) return GEO_ACCESS.MKT;
    const normalized = segment.replace(/-/g, '+').replace(/_/g, '/');
    const claims = JSON.parse(atob(normalized)) as { geoAccess?: unknown };
    return claims.geoAccess === GEO_ACCESS.OFFICE ? GEO_ACCESS.OFFICE : GEO_ACCESS.MKT;
  } catch {
    return GEO_ACCESS.MKT;
  }
}
